module.exports = __webpack_public_path__ + "static/media/bronchitis-gray.dcfb1413.svg";